import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TalentProfileApiService } from '../talent-profile-api.service';
import { TalentMoatsOpportunity } from '../../../../typings';
import { ActivityType, TalentProfilePage } from "../../../enums";
import { PageService } from "../shared/page-service";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { sendDoThisLaterEmail } from "../../shared/util/talent-happy-path-util";


@Component({
    selector: 'app-employment-preferences',
    templateUrl: './employment-preferences.component.html',
    styleUrls: ['./employment-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmploymentPreferencesComponent implements OnInit {
  form: FormGroup;
  isInitialLoad: boolean = false;
  talent: Talent;
  posting: PostingInfo;
  isModalVisible: boolean = false;

  @Input() fromNotAFit: boolean = false;

  constructor(
    private fb: FormBuilder,
    private talentProfileApiService: TalentProfileApiService,
    private pageService: PageService,
    private talentHappyPathDataService: TalentHappyPathDataService
  ) { }

  ngOnInit(): void {
    this.isInitialLoad = true;
    this.talent = this.talentHappyPathDataService.talent;
    this.posting = this.talentHappyPathDataService.postingInfo;
    this.form = this.fb.group({
      contractSelected: [false],
      contractToHireSelected: [false],
      permanentSelected: [false],
      fullTimeSelected: [false],
      partTimeSelected: [false],
      onSiteSelected: [false],
      hybridSelected: [false],
      offSiteSelected: [false]
    });

    this.loadPreferences();

    this.form.valueChanges.subscribe((values: TalentMoatsOpportunity) => {
      if (!this.isInitialLoad) {
        this.savePreferences(values);
      }
    });
  }

  toggleSelection(controlName: string) {
    const control = this.form.get(controlName);
    if (control) {
      control.setValue(!control.value);
    }
  }

  loadPreferences() {
    this.talentProfileApiService.getEmploymentOpportunity(this.talent.personId).subscribe(preferences => {
      this.form.patchValue(preferences);
      this.isInitialLoad = false;
    });
  }

  savePreferences(preferences: TalentMoatsOpportunity) {
    this.talentProfileApiService.saveEmploymentOpportunity(preferences, this.talent.personId).subscribe(response => {
      console.log('Preferences saved', response);
    }, error => {
      console.error('Error saving preferences', error);
    });
  }

  goToEmploymentOpportunities() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_OPPORTUNITIES);
  }

  goToEmploymentSalary() {
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_SALARY);
  }

  doThisLater() {
    if (!this.talentHappyPathDataService.doThisLaterEmailSent) {
      sendDoThisLaterEmail(
        this.posting?.jobPostingId ?? null,
        this.talent.personId,
        this.talent.firstName,
        this.talent.lastName,
        this.talent.email,
        this.posting?.jobTitle ?? null,
        this.posting?.orderId ?? null,
        this.talentProfileApiService,
        this.talentHappyPathDataService.isGeneralApplication
      )
    }
  }
}
